import { component, getter, action } from '../../decorators';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';

import { CHECKOUT_CART } from '../../store/actions';

import WbHeader from '../header/header.vue';
import Spinner from '../../components/common/spinner/spinner.vue';
import CartRow from './cart-row/cart-row.vue';
import CartSharing from '@/customers/cart-sharing/cart-sharing.vue';

import ComponentCreator from '@/helpers/component.creator';

import { CLIP_TYPE_CODE } from '../../config';

import Logger from '../../logger';

import Crud, { CARTS } from '../../api/crud';

const api = new Crud(CARTS);

const logger = new Logger('CartInfo');

@component({
   name: 'CartInfo',
   components: { WbHeader, Spinner, CartRow, CartSharing },
   watch: {
      isCartsLoaded: 'load'
   }
})
export default class CartInfo {
   loading = false;
   clips = [];
   currentCart = {};
   canShare = false;

   @getter('isCartsLoaded') isCartsLoaded
   @getter('getAllCartList') getAllCartList
   @getter('getCurrentShowId') showId
   @getter('getCurrentUser') currentUser

   /** @type {Function} */
   @action(CHECKOUT_CART) checkout;

   async load() {
      const id = +this.$route.params.cid;
      const cart = find(this.getAllCartList, { id });

      if (!cart) {
         return;
      }

      this.currentCart = cart;
      this.canShare = this.currentCart.userName === this.currentUser.userName;

      if ( isEmpty(this.currentCart.clipIds) ) {
         this.loading = false;
         this.clips = [];
         return;
      }

      await this.loadClips();
      this.loading = false;
   }

   async loadClips()
   {
      const id = +this.$route.params.cid;
      try {
         const data = await api.get(`${id}/clips`);
         data.forEach(i => i.type = CLIP_TYPE_CODE);
         this.clips = data;
      } catch(e) {
         logger.error(e);
         this.clips = [];
      }
   }

   async checkoutCart() {
      await this.checkout(this.currentCart);
      this.$router.push({ name: 'Carts' });
   }

   async displaySharePopup() {
      await ComponentCreator.dialog(CartSharing, { propsData: { cartId: this.currentCart.id, showId: this.showId } })
   }

   created() {
      this.loading = true;
      if ( this.isCartsLoaded && this.getAllCartList.length ) {
         this.load();
      }
   }
}
